@import 'modal';
@import 'spinners';

.modal-lightbox {

	.btn-close {
		position: absolute;
		top: $spacer;
		right: $spacer;
		opacity: .75;

		&:hover, &:focus {
			opacity: 1;
		}
	}

	.btn-link.visually-hidden-focusable:focus {
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
	}

	.modal-content {
		background: transparent;
		border: none;
	}

	.modal-spinner {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 1;
	}

	iframe,
	video {
		position: relative;
		z-index: 2;
		width: 100%;
	}

	video {
		height: auto;
	}
	
}